import {type ReactNode} from "react";
import {Box, Divider, Paper, Stack, Typography} from "@mui/material";
import {alpha} from "@mui/material/styles";

const SectionShell = ({
    eyebrow,
    title,
    action,
    children,
}: {
    eyebrow: string;
    title: string;
    action?: ReactNode;
    children: ReactNode;
}) => (
    <Paper
        elevation={0}
        sx={(theme) => ({
            borderRadius: 4,
            border: "1px solid",
            borderColor: theme.palette.divider,
            backgroundColor: alpha(theme.palette.background.paper, theme.palette.mode === "light" ? 0.82 : 0.92),
            backdropFilter: "blur(16px)",
            overflow: "hidden",
        })}
    >
        <Stack
            direction={{xs: "column", md: "row"}}
            justifyContent="space-between"
            alignItems={{xs: "flex-start", md: "center"}}
            spacing={2}
            sx={{px: {xs: 2.5, md: 3}, py: 2.5}}
        >
            <Box>
                <Typography
                    sx={(theme) => ({
                        fontFamily: theme.typography.fontFamily,
                        textTransform: "uppercase",
                        letterSpacing: 1.8,
                        fontWeight: 700,
                        fontSize: 12,
                        color: theme.palette.text.secondary,
                    })}
                >
                    {eyebrow}
                </Typography>
                <Typography
                    sx={(theme) => ({
                        fontFamily: theme.typography.h4.fontFamily || theme.typography.fontFamily,
                        fontSize: 26,
                        fontWeight: 800,
                        color: theme.palette.text.primary,
                    })}
                >
                    {title}
                </Typography>
            </Box>
            {action}
        </Stack>
        <Divider />
        <Box sx={{p: {xs: 2.5, md: 3}}}>{children}</Box>
    </Paper>
);

export default SectionShell;
